﻿export function throwsIfInvalidDate(date: Date, type: string): void {
	if (!isNaN(date.getTime())) {
		return
	}
	throw new Error(
		`Invalid date: ${date.toISOString()}. The ${type} constructor requires a valid date.`
	);
}

export function fromUtc(date: Date): Date {
	return createFromNumbers(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

export function createFromNumbers(year: number, month: number = 1, day: number = 1, hours: number = 0, minutes: number = 0, seconds: number = 0, milliseconds: number = 0): Date {
	return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, milliseconds));
}

export function getLastOfMonth(value: Date): number {
	return new Date(value.getFullYear(), value.getMonth() + 1, 0).getDate();
}

export function dateEquals(date1: Date, date2: Date | null | undefined): boolean {
	if (date2 == null) {
		return false;
	}

	return date1.getTime() === date2.getTime();
}

export function dateCompare(date1: Date, date2: Date | null | undefined): number {
	if (date2 == null) {
		return 1;
	}

	return date1.getTime() - date2.getTime();
}
